module.exports = __webpack_public_path__ + "static/img/contentBg.2e5baed5.png";